class DeliveryTime extends HTMLElement {
    constructor() {
        super();

        this.formatString = this.getAttribute("data-frm-day");
        this.excludedDays = this.getAttribute("data-exclude-day").replace(/ /g, '').split(",");
        this.numbDateStart = this.getAttribute("data-estimate-start");
        this.numbDateEnd = this.getAttribute("data-estimate-end");
        this.iso_code = document.documentElement.lang;
        
        this.checkExclude = this.checkAllExcludeDays(this.excludedDays);

        if (this.checkExclude) {
            this.style.display = "none"; // Hide if it's a non-shipping day
            return;
        }

        this.productDeliveryTime();
        this.style.display = "block"; // Show the delivery date info
    }

    checkAllExcludeDays(excludedDays) {
        const now = new Date();
        const deliveryDateTime = new Date(now);
        for (let day of excludedDays) {
            const dayIndex = ['SUN', 'MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT'].indexOf(day);
            if (deliveryDateTime.getDay() === dayIndex) return true;
        }
        return false;
    }

    productDeliveryTime() {
        const $orderDlvr = $("[data-delivery-time]");
        if ($orderDlvr.length == 0) return;

        let startDay = this.excludeDays(this.excludedDays, this.numbDateStart);
        let endDay = this.excludeDays(this.excludedDays, this.numbDateEnd);

        const formattedStartDate = this.formatDate(startDay, this.formatString);
        const formattedEndDate = this.formatDate(endDay, this.formatString);

        $orderDlvr.find('[data-start-delivery]').html(formattedStartDate);
        $orderDlvr.find('[data-end-delivery]').html(formattedEndDate);
    }

formatDate(dateString, formatString) {
    const date = new Date(dateString);
    const locale = window.iso_code || 'en-US';
    const dayNum = date.getDate();
    
    // 1. Determine the correct suffix
    let suffix = 'th';
    if (dayNum % 10 === 1 && dayNum !== 11) suffix = 'st';
    else if (dayNum % 10 === 2 && dayNum !== 12) suffix = 'nd';
    else if (dayNum % 10 === 3 && dayNum !== 13) suffix = 'rd';

    // 2. Prepare the parts
    const dayOfWeek = date.toLocaleDateString(locale, { weekday: 'long' });
    const month = date.toLocaleDateString(locale, { month: 'short' });
    const year = date.toLocaleDateString(locale, { year: 'numeric' });

    // 3. The Strict Replace:
    // We remove any manually typed 'th' from the format string first
    let cleanFormat = formatString.replace(/st|nd|rd|th/gi, '');

    return cleanFormat
        .replace('d', dayOfWeek)
        .replace('DD', dayNum + suffix)
        .replace('MMM', month)
        .replace('YYYY', year);
}

    excludeDays(excludedDays, dataRange) {
        const deliveryDateTime = new Date();
        deliveryDateTime.setDate(deliveryDateTime.getDate() + parseInt(dataRange));
        excludedDays.forEach(day => {
            const dayIndex = ['SUN', 'MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT'].indexOf(day);
            if (deliveryDateTime.getDay() === dayIndex) {
                deliveryDateTime.setDate(deliveryDateTime.getDate() + 1);
            }
        });
        return deliveryDateTime.toLocaleDateString('en-US');
    }
}
customElements.define('delivery-time', DeliveryTime);